import { useState } from 'react';
import LegalPage from '../shared/LegalPage';
import { business } from '../content';
import { useLanguage } from '../language/LanguageContext';
import { fillTemplate } from '../language/translations';

const DELETE_REQUEST_ENDPOINT =
  process.env.REACT_APP_DELETE_REQUEST_ENDPOINT ||
  'https://citybarber.mk/api/account/delete_request.php';

function DeleteAccountRequest() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    const normalizedEmail = email.trim().toLowerCase();

    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch(DELETE_REQUEST_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: normalizedEmail })
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || result.success === false) {
        throw new Error(result.message || 'Request failed');
      }

      setStatus('success');
      setEmail(normalizedEmail);
      setMessage(
        fillTemplate(t.deleteRequest.successMessage, {
          appName: business.appName,
          email: normalizedEmail
        })
      );
    } catch (error) {
      setStatus('error');
      setMessage(t.deleteRequest.errorMessage);
    }
  }

  return (
    <LegalPage
      title={t.deleteRequest.title}
      intro={fillTemplate(t.deleteRequest.intro, { appName: business.appName })}
    >
      <section className="support-box">
        <h2>{t.deleteRequest.formTitle}</h2>
        <p>{t.deleteRequest.formText}</p>

        <form className="deletion-form" onSubmit={handleSubmit}>
          <label htmlFor="delete-account-email">{t.deleteRequest.emailLabel}</label>
          <input
            id="delete-account-email"
            type="email"
            required
            autoComplete="email"
            inputMode="email"
            value={email}
            placeholder={t.deleteRequest.emailPlaceholder}
            onChange={(event) => setEmail(event.target.value)}
          />
          <button className="button primary" type="submit" disabled={status === 'loading'}>
            {status === 'loading' ? t.deleteRequest.submittingCta : t.deleteRequest.submitCta}
          </button>
        </form>

        {message && <p className={`form-message ${status}`}>{message}</p>}
      </section>

      <section>
        <h2>{t.deleteRequest.emailTitle}</h2>
        <p>{t.deleteRequest.emailText}</p>
      </section>

      <section>
        <h2>{t.deleteRequest.backendTitle}</h2>
        <p>{t.deleteRequest.backendText}</p>
      </section>
    </LegalPage>
  );
}

export default DeleteAccountRequest;
